export enum AppRouteParam {
  Id = 'id',
  SurveyId = 'surveyId',
  SessionId = 'sessionId',
  RoleId = 'roleId',
  EmployeeId = 'employeeId',
  EmployeeGroupsId = 'employeeGroupsId',
  CampaignId = 'campaignId',
}
